var image_viewer_rtlignore_default = {
  "fontElementMap": "_547Gg",
  "imageContainer": "oMGcg",
  "expandButton": "Ky28X",
  "expandIcon": "Jwo3D",
  "pointer": "nU4OB",
  "imageWrapper": "MYKWZ",
  "imageRatio": "PMatv",
  "image": "Zh5S6",
  "imageOverlay": "rVd1A",
  "imagePreload": "VC-nO",
  "imageHighres": "Kpfl-",
  "onlyHighRes": "oGCr-",
  "image_loading": "veq6v"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
